import { ColorsConfig } from '../colors/colors.config';


export class ExposureBreakdownConfig {
	public static readonly FI_SECTOR_ALLOCATION = [
		{
			name: 'Government',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['government'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[0] }
		},
		{
			name: 'Corporate',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['corporateBond'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[1] }
		},
		{
			name: 'Securitized',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['securitized'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[2] }
		},
		{
			name: 'Municipal',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['municipal'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[3] }
		},
		{
			name: 'Cash & Equivalents',
			isParent: false,
			isSummation: true,
			includedAsEmpty: true,
			values: ['cashAndEquivalents'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[4] }
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			includedAsEmpty: false,
			values: ['derivatives', 'other'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_COLOR_FOR_OTHER }
		}
	];
	public static readonly EQ_REGION = [
		{
			name: 'INTERNATIONAL',
			isParent: false,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Developed except canada', 'Emerging', 'canada'],
			attributes: { ignoreInChart: true, includedAsSubHeader: true }
		},
		{
			name: 'US',
			isParent: false,
			isSummation: true,
			includedAsEmpty: true,
			values: ['northAmerica'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[0] }
		},
		{
			name: 'Developed',
			isParent: false,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Developed except canada', 'canada'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[1] }
		},
		{
			name: 'Emerging',
			isParent: false,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Emerging'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[2] }
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: false,
			includedAsEmpty: false,
			values: ['Unknown'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_COLOR_FOR_OTHER }
		}
	];
	public static readonly EQ_REGION_EXCEPT_NA = [
		{
			name: 'Developed except canada',
			isParent: false,
			isSummation: true,
			values: ['unitedKingdom', 'europeDeveloped', 'japan', 'australasia', 'asiaDeveloped']
		},
		{
			name: 'Emerging',
			isParent: false,
			isSummation: true,
			values: ['africaAndMiddleEast', 'europeEmerging', 'asiaEmerging', 'latinAmerica']
		},
		{
			name: 'Unknown',
			isParent: false,
			isSummation: false,
			values: ['other_combined']
		}
	];
	// required for mapping when data is coming from asset-resolve
	public static IQ_EQ_REGION_SUBGROUP = [
		{
			name: 'Africa and MiddleEast',
			id: 'africaAndMiddleEast',
			values: ['africa', 'middleEast']
		},
		{
			name: 'Europe Developed',
			id: 'europeDeveloped',
			values: ['eurozone', 'europeExEuro']
		}
	];
	public static readonly EQ_REGION_GROUP = [
		{
			name: 'United States',
			noChildren: true,
			values: ['unitedStates']
		},
		{
			name: 'Developed Markets',
			values: ['canada', 'unitedKingdom', 'europeDeveloped', 'asiaDeveloped', 'japan', 'australasia']
		},
		{
			name: 'Emerging Markets',
			values: ['latinAmerica', 'europeEmerging', 'africaAndMiddleEast', 'asiaEmerging']
		},
		{
			name: 'Other',
			noChildren: true,
			values: ['other_combined', 'unknown'] // unknown is what we get from asset-resolve
		}
	];
	public static readonly EMERGING_MARKETS = [
		{
			name: 'Emerging',
			isParent: false,
			isSummation: true,
			values: ['africaAndMiddleEast', 'europeEmerging', 'asiaEmerging', 'latinAmerica'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[0] }

		}
	];
	public static readonly COHORT_EMERGING_MARKETS = [
		{
			name: 'Cohort Emerging',
			isParent: false,
			isSummation: true,
			values: ['africaAndMiddleEast', 'europeEmerging', 'asiaEmerging', 'latinAmerica'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[1] }
		}
	];
	public static readonly EQ_REGION_NA_ONLY = [
		{
			name: 'northAmerica',
			isParent: false,
			isSummation: true,
			values: ['unitedStates']
		},
		{
			name: 'canada',
			isParent: false,
			isSummation: true,
			values: ['canada']
		}
	];

	public static readonly ASSET_ALLOCATION_GROUPS_COLLAPSED = [
		{
			name: 'Equity',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: [
				'usStock',
				'nonUsStock'
			]
		},
		{
			name: 'US Stock',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['usStock'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.usStock }
		},
		{
			name: 'Non US Stock',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['nonUsStock'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.nonUsStock }
		},
		{
			name: 'Fixed Income',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: [
				'usBond',
				'nonUsBond'
			]
		},
		{
			name: 'US Bond',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['usBond'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.usBond }
		},
		{
			name: 'Non US Bond',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['nonUsBond'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.nonUsBond }
		},
		{
			name: 'Cash',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['cash'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.cash }
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['other'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.other }
		}
	];

	public static readonly ASSET_ALLOCATION_FULL_NAME = [
		{
			name: 'US Stocks',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['usStock'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.usStock }
		},
		{
			name: 'Non US Stock',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['nonUsStock'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.nonUsStock }
		},
		{
			name: 'US Bonds',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['usBond'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.usBond }
		},
		{
			name: 'Non US Bonds',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['nonUsBond'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.nonUsBond }
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			includedAsEmpty: true,
			values: ['other'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.other }
		},
		{
			name: 'Cash',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['cash'],
			attributes: { colorTheme: ColorsConfig.ASSET_ALLOCATION_COLORS.cash }
		}
	];

	public static readonly ASSET_CLASS_DECOMPOSITION = [
		{
			name: 'US Equities',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['usEquities'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.usEquities }
		},
		{
			name: 'Cash',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['cash'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.cash }
		},
		{
			name: 'Non-US/Int\'l Equities',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['globalEquities', 'sectorEquities'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.nonUSInternationalEquities }
		},
		{
			name: 'US Fixed Income',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['usFixedIncome'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.usFixedIncome }
		},
		{
			name: 'Non-US/Int\'l Fixed Income',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['globalFixedIncome'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.nonUSInternationalFixedIncome }
		},
		{
			name: 'Multi Asset',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['multiAsset'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.multiAsset }
		},
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: false,
			includedAsEmpty: true,
			values: ['alternatives'],
			attributes: { colorTheme: ColorsConfig.ASSET_CLASS_DECOMPOSITION_COLORS.alternatives }
		}
	];

	public static readonly ASSET_ALLOCATION = [
		{
			name: 'US Stock',
			values: ['usStock'],
			includedAsEmpty: true
		},
		{
			name: 'Non US Stock',
			values: ['nonUsStock'],
			includedAsEmpty: true
		},
		{
			name: 'US Bond',
			values: ['usBond'],
			includedAsEmpty: true
		},
		{
			name: 'Non US Bond',
			values: ['nonUsBond'],
			includedAsEmpty: true
		},
		{
			name: 'Cash',
			values: ['cash'],
			includedAsEmpty: true
		},
		{
			name: 'Other',
			values: ['other'],
			includedAsEmpty: true
		}
	];

	public static readonly CREDIT_QUALITY_GROUPS = [
		{
			name: 'AAA',
			infoBubble: 'AAA_TOOLTIP',
			values: ['aaa']
		},
		{
			name: 'Investment Grade',
			infoBubble: 'INVESTMENT_GRADE_TOOLTIP',
			values: ['a', 'aa', 'bbb']
		},
		{
			name: 'High Yield',
			infoBubble: 'HIGH_YIELD_TOOLTIP',
			values: ['bb', 'b', 'belowb']
		},
		{
			name: 'Not Rated',
			infoBubble: 'NOT_RATED_TOOLTIP',
			values: ['notrated', 'unknown', 'other']
		}
	];

	public static readonly STOCK_SECTOR_GROUPS = [
		{
			name: 'Basic Materials',
			values: ['basicMaterials']
		},
		{
			name: 'Communication Services',
			values: ['communicationServices']
		},
		{
			name: 'Consumer Cyclical',
			values: ['consumerCyclical']
		},
		{
			name: 'Consumer Defensive',
			values: ['consumerDefensive']
		},
		{
			name: 'Energy',
			values: ['energy']
		},
		{
			name: 'Financial Services',
			values: ['financialServices']
		},
		{
			name: 'Healthcare',
			values: ['healthcare']
		},
		{
			name: 'Industrials',
			values: ['industrials']
		},
		{
			name: 'Technology',
			values: ['technology']
		},
		{
			name: 'Real Estate',
			values: ['realEstate']
		},
		{
			name: 'Utilities',
			values: ['utilities']
		},
		{
			name: 'Other',
			values: ['unknown', 'other']
		}
	];

	// to be removed once migration is done in IQ
	public static readonly FI_BOND_SECTOR_GROUPS = [
		{
			name: 'Government',
			id: 'government',
			values: ['government', 'governmentRelated']
		},
		{
			name: 'Municipal',
			id: 'municipalTaxable',
			values: ['municipalTaxable', 'usMunicipalTaxAdvantaged']
		},
		{
			name: 'Corporate',
			id: 'corporateBond',
			values: ['corporateBond', 'convertible', 'bankLoan', 'preferred']
		},
		{
			name: 'Securitized',
			id: 'agencyMortgageBacked',
			values: ['agencyMortgageBacked', 'assetBacked', 'commercialMortgageBacked', 'coveredBond', 'nonAgencyResidentialMortgageBacked']
		},
		{
			name: 'Derivatives',
			id: 'swap',
			values: ['swap', 'optionWarrant', 'futureForward']
		},
		{
			name: 'Cash & Equivalents',
			id: 'cashAndEquivalents',
			values: ['cashAndEquivalents']
		},
		{
			name: 'Other',
			id: 'Unknown',
			values: ['Unknown', 'unknown', 'other', 'Other']
		}
	];

	public static readonly FI_BOND_SECTOR_GROUPS_PAS = [
		{
			name: 'Government',
			id: 'government',
			values: ['government']
		},
		{
			name: 'Municipal',
			id: 'municipalTaxable',
			values: ['municipal']
		},
		{
			name: 'Corporate',
			id: 'corporateBond',
			values: ['corporateBond']
		},
		{
			name: 'Securitized',
			id: 'agencyMortgageBacked',
			values: ['securitized']
		},
		{
			name: 'Derivatives',
			id: 'derivatives',
			values: ['derivatives']
		},
		{
			name: 'Cash & Equivalents',
			id: 'cashAndEquivalents',
			values: ['cashAndEquivalents']
		},
		{
			name: 'Other',
			id: 'Unknown',
			values: ['other']
		}
	];

	public static readonly Nile_BOND_SECTOR_GROUPS = [
		{
			name: 'Treasuries/Gov Bonds',
			id: 'government',
			values: ['government']
		},
		{
			name: 'Government Related',
			id: 'governmentRelatedCombo',
			values: ['governmentRelatedCombo']
		},
		{
			name: 'Corporate',
			id: 'corporateBond',
			values: ['corporateBond']
		},
		{
			name: 'Securitized',
			id: 'securitized',
			values: ['securitized']
		},
		{
			name: 'Derivatives',
			id: 'derivatives',
			values: ['derivatives']
		},
		{
			name: 'Cash & Equivalents',
			id: 'cashAndEquivalents',
			values: ['cashAndEquivalents']
		},
		{
			name: 'Other',
			id: 'other',
			values: ['Unknown', 'unknown', 'other', 'Other']
		}
	];

	public static readonly STOCK_STYLE = [
		{
			name: 'Large',
			values: ['Large Value', 'Large Blend', 'Large Growth']
		},
		{
			name: 'Mid',
			values: ['Mid Value', 'Mid Blend', 'Mid Growth']
		},
		{
			name: 'Small',
			values: ['Small Value', 'Small Blend', 'Small Growth']
		},
		{
			name: 'Uncategorised',
			noChildren: true,
			values: ['Other', 'Unknown']
		}
	];
	public static readonly STOCK_STYLE_CHILDREN_GROUP = [
		{
			name: 'Large Value',
			values: ['largeValue']
		},
		{
			name: 'Large Blend',
			values: ['largeBlend']
		},
		{
			name: 'Large Growth',
			values: ['largeGrowth']
		},
		{
			name: 'Mid Value',
			values: ['midValue']
		},
		{
			name: 'Mid Blend',
			values: ['midBlend']
		},
		{
			name: 'Mid Growth',
			values: ['midGrowth']
		},
		{
			name: 'Small Value',
			values: ['smallValue']
		},
		{
			name: 'Small Blend',
			values: ['smallBlend']
		},
		{
			name: 'Small Growth',
			values: ['smallGrowth']
		}
	];
	public static readonly PAC_BREAKDOWN_EQUITY_SECTORS = [
		{
			name: 'Basic Materials',
			isParent: false,
			isSummation: false,
			values: ['Basic Materials']
		},
		{
			name: 'Communication Services',
			isParent: false,
			isSummation: false,
			values: ['Communication Services']
		},
		{
			name: 'Consumer Cyclical',
			isParent: false,
			isSummation: false,
			values: ['Consumer Cyclical']
		},
		{
			name: 'Consumer Defensive',
			isParent: false,
			isSummation: false,
			values: ['Consumer Defensive']
		},
		{
			name: 'Energy',
			isParent: false,
			isSummation: false,
			values: ['Energy']
		},
		{
			name: 'Financial Services',
			isParent: false,
			isSummation: false,
			values: ['Financial Services']
		},
		{
			name: 'Healthcare',
			isParent: false,
			isSummation: false,
			values: ['Healthcare']
		},
		{
			name: 'Industrials',
			isParent: false,
			isSummation: false,
			values: ['Industrials']
		},
		{
			name: 'Real Estate',
			isParent: false,
			isSummation: false,
			values: ['Real Estate']
		},
		{
			name: 'Technology',
			isParent: false,
			isSummation: false,
			values: ['Technology']
		},
		{
			name: 'Utilities',
			isParent: false,
			isSummation: false,
			values: ['Utilities']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			values: ['Other', 'Unknown']
		}
	];

	public static readonly PAC_BREAKDOWN_FI_CREDIT_RATINGS = [
		{
			name: 'AAA',
			isParent: false,
			isSummation: false,
			values: ['aaa']
		},
		{
			name: 'AA',
			isParent: false,
			isSummation: false,
			values: ['aa']
		},
		{
			name: 'A',
			isParent: false,
			isSummation: false,
			values: ['a']
		},
		{
			name: 'BBB',
			isParent: false,
			isSummation: false,
			values: ['bbb']
		},
		{
			name: 'BB',
			isParent: false,
			isSummation: false,
			values: ['bb']
		},
		{
			name: 'B',
			isParent: false,
			isSummation: false,
			values: ['b']
		},

		{
			name: 'Below B',
			isParent: false,
			isSummation: false,
			values: ['belowB']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			values: ['other', 'unknown']
		},
		{
			name: 'Not Rated',
			isParent: false,
			isSummation: false,
			values: ['notRated']
		}
	];

	// mapping for megatrends; if new megatrends need to be added, the first value in the values array should be '-mc' due to the legend color mapping (order matters)
	public static readonly MEGATRENDS_SUM_GROUPS = [
		{
			name: 'Aerospace & Defense',
			values: ['AerospaceDefense-MegaCap', 'AerospaceDefense']
		},
		{
			name: 'Batteries & Energy Storage',
			values: ['BatteriesEnergyStorage-MegaCap', 'BatteriesEnergyStorage']
		},
		{
			name: 'Blockchain',
			values: ['Blockchain-MegaCap', 'Blockchain']
		},
		{
			name: 'Clean Energy',
			values: ['CleanEnergy-MegaCap', 'CleanEnergy']
		},
		{
			name: 'Cloud Computing & 5G',
			values: ['CloudComputing5G-MegaCap', 'CloudComputing5G']
		},
		{
			name: 'Cybersecurity',
			values: ['Cybersecurity-MegaCap', 'Cybersecurity']
		},
		{
			name: 'Digital Infrastructure',
			values: ['DigitalInfrastructure-MegaCap', 'DigitalInfrastructure']
		},
		{
			name: 'Electric & Autonomous Vehicles',
			values: ['ElectricAutonomousVehicles-MegaCap', 'ElectricAutonomousVehicles']
		},
		{
			name: 'Environmental Infrastructure',
			values: ['EnvironmentalInfrastructure-MegaCap', 'EnvironmentalInfrastructure']
		},
		{
			name: 'Future Food & AgTech',
			values: ['FutureFoodAgTech-MegaCap', 'FutureFoodAgTech']
		},
		{
			name: 'Genomics & Immunology',
			values: ['GenomicsImmunology-MegaCap', 'GenomicsImmunology']
		},
		{
			name: 'Green Tech',
			values: ['Greentech-MegaCap', 'Greentech']
		},
		{
			name: 'Medical Devices',
			values: ['MedicalDevices-MegaCap', 'MedicalDevices']
		},
		{
			name: 'Neuroscience',
			values: ['Neuroscience-MegaCap', 'Neuroscience']
		},
		{
			name: 'Robotics & AI',
			values: ['RoboticsAI-MegaCap', 'RoboticsAI']
		},
		{
			name: 'Semiconductors',
			values: ['Semiconductors-MegaCap', 'Semiconductors']
		},
		{
			name: 'U.S. Infrastructure',
			values: ['USInfrastructure-MegaCap', 'USInfrastructure']
		},
		{
			name: 'U.S. Manufacturing',
			values: ['USManufacturing-MegaCap', 'USManufacturing']
		}
	];

	public static readonly OTHER_SUM_GROUPS = [
		{
			name: 'Other',
			values: ['Unknown', 'unknown', 'other', 'Other']
		}
	];

	public static readonly NILE_REGION_BREAKDOWN_GROUPS = [
		{
			name: 'Developed Markets',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			infoBubble: 'REGION_BREAKDOWN_DEVELOPED_MARKETS_INFO_BUBBLE',
			values: ['asiaDeveloped', 'australasia', 'canada', 'europeExEuro', 'eurozone', 'japan', 'unitedKingdom', 'unitedStates']
		},
		{
			name: 'US',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['unitedStates']
		},
		{
			name: 'Canada',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['canada']
		},
		{
			name: 'UK',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['unitedKingdom']
		},
		{
			name: 'EuroZone',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['eurozone']
		},
		{
			name: 'EuropeExEuro',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['europeExEuro']
		},
		{
			name: 'Japan',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['japan']
		},
		{
			name: 'Asia Developed',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['asiaDeveloped']
		},
		{
			name: 'Australia',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['australasia']
		},
		{
			name: 'Emerging Markets',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			infoBubble: 'REGION_BREAKDOWN_EMERGING_MARKETS_INFO_BUBBLE',
			values: ['africa', 'asiaEmerging', 'europeEmerging', 'latinAmerica', 'middleEast']
		},
		{
			name: 'Latin America',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['latinAmerica']
		},
		{
			name: 'Europe Emerging',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['europeEmerging']
		},
		{
			name: 'Middle East',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['middleEast']
		},
		{
			name: 'Africa',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['africa']
		},
		{
			name: 'Asia Emerging',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['asiaEmerging']
		},
		{
			name: 'Uncategorized',
			isParent: false,
			isSummation: false,
			isGroupHeader: true,
			infoBubble: 'REGION_BREAKDOWN_UNCATEGORIZED_INFO_BUBBLE',
			values: ['Other', 'other', 'other_combined']
		}
	];
}
